module.exports = __webpack_public_path__ + "static/media/3.ce072bf6.jpg";